import { IRoute, RenderRoutes } from "@src/routes";
import orderRoutes from "@reimbursement/batch/routes";
import conciliationsRoutes from "@reimbursement/conciliations/routes";

const mdRoutes: IRoute[] = [
  {
    menu: { label: "Monitoro Distribuidores" },
    path: "/reimbursement",
    key: "MD_ROOT",
    component: (props: any) => <RenderRoutes {...props} />,
    routes: [
      ...orderRoutes,
    ],
  },
  {
    menu: { label: "Monitoro Distribuidores" },
    path: "/conciliations",
    key: "CO_ROOT",
    component: (props: any) => <RenderRoutes {...props} />,
    routes: [
      ...conciliationsRoutes,
    ],
  },
];

export default mdRoutes;
